export function cardView(card) {
  const classes = [];
  if (card.color) classes.push("tg-tone-custom");
  if (card.group) classes.push("tg-card-group");
  if (card.cancelled) classes.push("tg-card-cancelled");
  return {
    classes,
    label: `${card.title} booking`,
    slots: { service: card.service, title: card.title, owner: card.owner },
    rows: card.rows || [],
    href: card.url,
    color: card.color || null,
    tint: card.tint || null,
  };
}

export function parsePayload(text) {
  try {
    return JSON.parse(text || "{}");
  } catch (_error) {
    return {};
  }
}

export function mountPoint(container) {
  return container.querySelector(".tg-mobile") || container;
}
